//import { ILanguageDomainValues, ILanguageDomainValuesAction } from 'models/languages/languagedomainvalues';
import { IDomainValues, IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { changeUserLanguage } from 'redux/modules/user/userlanguage';
import {
	ILanguage,
	IDomainValue,
	ICountryCallingCodeDomainValue,
	ICategoryDomainValue,
	IServiceCategoryDomainValue,
	IServiceCategoryShopType,
} from 'models/common';
import { I18nextSettings } from '../../../containers';
import { IStore } from 'redux/IStore';

/** Action Types */
export const GET_COUNTRIES_REQUEST_START: string = 'domainvalues/GET_COUNTRIES_REQUEST_START';
export const GET_COUNTRIES_REQUEST_FAILURE: string = 'domainvalues/GET_COUNTRIES_REQUEST_FAILURE';
export const GET_COUNTRIES_SUCCESS: string = 'domainvalues/GET_COUNTRIES_SUCCESS';

export const GET_LANGUAGES_REQUEST_START: string = 'domainvalues/GET_LANGUAGES_REQUEST_START';
export const GET_LANGUAGES_REQUEST_FAILURE: string = 'domainvalues/GET_LANGUAGES_REQUEST_FAILURE';
export const GET_LANGUAGES_SUCCESS: string = 'domainvalues/GET_LANGUAGES_SUCCESS';

export const GET_COUNTRY_CALLING_CODES_REQUEST_START: string = 'domainvalues/GET_COUNTRY_CALLING_CODES_REQUEST_START';
export const GET_COUNTRY_CALLING_CODES_REQUEST_FAILURE: string =
	'domainvalues/GET_COUNTRY_CALLING_CODES_REQUEST_FAILURE';
export const GET_COUNTRY_CALLING_CODES_SUCCESS: string = 'domainvalues/GET_COUNTRY_CALLING_CODES_SUCCESS';

export const GET_CATEGORIES_REQUEST_START: string = 'domainvalues/GET_CATEGORIES_REQUEST_START';
export const GET_CATEGORIES_REQUEST_FAILURE: string = 'domainvalues/GET_CATEGORIES_REQUEST_FAILURE';
export const GET_CATEGORIES_SUCCESS: string = 'domainvalues/GET_CATEGORIES_SUCCESS';

export const GET_COLORS_REQUEST_START: string = 'domainvalues/GET_COLORS_REQUEST_START';
export const GET_COLORS_REQUEST_FAILURE: string = 'domainvalues/GET_COLORS_REQUEST_FAILURE';
export const GET_COLORS_SUCCESS: string = 'domainvalues/GET_COLORS_SUCCESS';

export const GET_MATERIALS_REQUEST_START: string = 'domainvalues/GET_MATERIALS_REQUEST_START';
export const GET_MATERIALS_REQUEST_FAILURE: string = 'domainvalues/GET_MATERIALS_REQUEST_FAILURE';
export const GET_MATERIALS_SUCCESS: string = 'domainvalues/GET_MATERIALS_SUCCESS';

export const GET_PRINTS_REQUEST_START: string = 'domainvalues/GET_PRINTS_REQUEST_START';
export const GET_PRINTS_REQUEST_FAILURE: string = 'domainvalues/GET_PRINTS_REQUEST_FAILURE';
export const GET_PRINTS_SUCCESS: string = 'domainvalues/GET_PRINTS_SUCCESS';

export const GET_SIZES_REQUEST_START: string = 'domainvalues/GET_SIZES_REQUEST_START';
export const GET_SIZES_REQUEST_FAILURE: string = 'domainvalues/GET_SIZES_REQUEST_FAILURE';
export const GET_SIZES_SUCCESS: string = 'domainvalues/GET_SIZES_SUCCESS';

export const GET_STYLES_REQUEST_START: string = 'domainvalues/GET_STYLES_REQUEST_START';
export const GET_STYLES_REQUEST_FAILURE: string = 'domainvalues/GET_STYLES_REQUEST_FAILURE';
export const GET_STYLES_SUCCESS: string = 'domainvalues/GET_STYLES_SUCCESS';

export const GET_TOPICS_REQUEST_START: string = 'domainvalues/GET_TOPICS_REQUEST_START';
export const GET_TOPICS_REQUEST_FAILURE: string = 'domainvalues/GET_TOPICS_REQUEST_FAILURE';
export const GET_TOPICS_SUCCESS: string = 'domainvalues/GET_TOPICS_SUCCESS';

export const GET_CURRENCIES_REQUEST_START: string = 'domainvalues/GET_CURRENCIES_REQUEST_START';
export const GET_CURRENCIES_REQUEST_FAILURE: string = 'domainvalues/GET_CURRENCIES_REQUEST_FAILURE';
export const GET_CURRENCIES_SUCCESS: string = 'domainvalues/GET_CURRENCIES_SUCCESS';

export const GET_SKIN_TYPES_REQUEST_START: string = 'domainvalues/GET_SKIN_TYPES_REQUEST_START';
export const GET_SKIN_TYPES_REQUEST_FAILURE: string = 'domainvalues/GET_SKIN_TYPES_REQUEST_FAILURE';
export const GET_SKIN_TYPES_SUCCESS: string = 'domainvalues/GET_SKIN_TYPES_SUCCESS';

export const GET_SPECIALITIES_REQUEST_START: string = 'domainvalues/GET_SPECIALITIES_REQUEST_START';
export const GET_SPECIALITIES_REQUEST_FAILURE: string = 'domainvalues/GET_SPECIALITIES_REQUEST_FAILURE';
export const GET_SPECIALITIES_SUCCESS: string = 'domainvalues/GET_SPECIALITIES_SUCCESS';

export const GET_FORMATS_REQUEST_START: string = 'domainvalues/GET_FORMATS_REQUEST_START';
export const GET_FORMATS_REQUEST_FAILURE: string = 'domainvalues/GET_FORMATS_REQUEST_FAILURE';
export const GET_FORMATS_SUCCESS: string = 'domainvalues/GET_FORMATS_SUCCESS';

export const GET_FORMULATIONS_REQUEST_START: string = 'domainvalues/GET_FORMULATIONS_REQUEST_START';
export const GET_FORMULATIONS_REQUEST_FAILURE: string = 'domainvalues/GET_FORMULATIONS_REQUEST_FAILURE';
export const GET_FORMULATIONS_SUCCESS: string = 'domainvalues/GET_FORMULATIONS_SUCCESS';

export const GET_TREATMENTS_REQUEST_START: string = 'domainvalues/GET_TREATMENTS_REQUEST_START';
export const GET_TREATMENTS_REQUEST_FAILURE: string = 'domainvalues/GET_TREATMENTS_REQUEST_FAILURE';
export const GET_TREATMENTS_SUCCESS: string = 'domainvalues/GET_TREATMENTS_SUCCESS';

export const GET_SPORTS_REQUEST_START: string = 'domainvalues/GET_SPORTS_REQUEST_START';
export const GET_SPORTS_REQUEST_FAILURE: string = 'domainvalues/GET_SPORTS_REQUEST_FAILURE';
export const GET_SPORTS_SUCCESS: string = 'domainvalues/GET_SPORTS_SUCCESS';

export const GET_HOBBIES_REQUEST_START: string = 'domainvalues/GET_HOBBIES_REQUEST_START';
export const GET_HOBBIES_REQUEST_FAILURE: string = 'domainvalues/GET_HOBBIES_REQUEST_FAILURE';
export const GET_HOBBIES_SUCCESS: string = 'domainvalues/GET_HOBBIES_SUCCESS';

export const GET_TRIPS_REQUEST_START: string = 'domainvalues/GET_TRIPS_REQUEST_START';
export const GET_TRIPS_REQUEST_FAILURE: string = 'domainvalues/GET_TRIPS_REQUEST_FAILURE';
export const GET_TRIPS_SUCCESS: string = 'domainvalues/GET_TRIPS_SUCCESS';

export const GET_SOCIALS_REQUEST_START: string = 'domainvalues/GET_SOCIALS_REQUEST_START';
export const GET_SOCIALS_REQUEST_FAILURE: string = 'domainvalues/GET_SOCIALS_REQUEST_FAILURE';
export const GET_SOCIALS_SUCCESS: string = 'domainvalues/GET_SOCIALS_SUCCESS';

export const GET_HAIRTYPE_REQUEST_START: string = 'domainvalues/GET_HAIRTYPE_REQUEST_START';
export const GET_HAIRTYPE_REQUEST_FAILURE: string = 'domainvalues/GET_HAIRTYPE_REQUEST_FAILURE';
export const GET_HAIRTYPE_SUCCESS: string = 'domainvalues/GET_HAIRTYPE_SUCCESS';

export const GET_SCALPMOISTURE_REQUEST_START: string = 'domainvalues/GET_SCALPMOISTURE_REQUEST_START';
export const GET_SCALPMOISTURE_REQUEST_FAILURE: string = 'domainvalues/GET_SCALPMOISTURE_REQUEST_FAILURE';
export const GET_SCALPMOISTURE_SUCCESS: string = 'domainvalues/GET_SCALPMOISTURE_SUCCESS';

export const GET_HAIRDRESSERVISITSPERMONTH_REQUEST_START: string =
	'domainvalues/GET_HAIRDRESSERVISITSPERMONTH_REQUEST_START';
export const GET_HAIRDRESSERVISITSPERMONTH_REQUEST_FAILURE: string =
	'domainvalues/GET_HAIRDRESSERVISITSPERMONTH_REQUEST_FAILURE';
export const GET_HAIRDRESSERVISITSPERMONTH_SUCCESS: string = 'domainvalues/GET_HAIRDRESSERVISITSPERMONTH_SUCCESS';

export const GET_HAIRPRODUCTS_REQUEST_START: string = 'domainvalues/GET_HAIRPRODUCTS_REQUEST_START';
export const GET_HAIRPRODUCTS_REQUEST_FAILURE: string = 'domainvalues/GET_HAIRPRODUCTS_REQUEST_FAILURE';
export const GET_HAIRPRODUCTS_SUCCESS: string = 'domainvalues/GET_HAIRPRODUCTS_SUCCESS';

export const GET_GOALS_REQUEST_START: string = 'domainvalues/GET_GOALS_REQUEST_START';
export const GET_GOALS_REQUEST_FAILURE: string = 'domainvalues/GET_GOALS_REQUEST_FAILURE';
export const GET_GOALS_SUCCESS: string = 'domainvalues/GET_GOALS_SUCCESS';

export const GET_SKINCOLOR_REQUEST_START: string = 'domainvalues/GET_SKINCOLOR_REQUEST_START';
export const GET_SKINCOLOR_REQUEST_FAILURE: string = 'domainvalues/GET_SKINCOLOR_REQUEST_FAILURE';
export const GET_SKINCOLOR_SUCCESS: string = 'domainvalues/GET_SKINCOLOR_SUCCESS';

export const GET_EYESCOLOR_REQUEST_START: string = 'domainvalues/GET_EYESCOLOR_REQUEST_START';
export const GET_EYESCOLOR_REQUEST_FAILURE: string = 'domainvalues/GET_EYESCOLOR_REQUEST_FAILURE';
export const GET_EYESCOLOR_SUCCESS: string = 'domainvalues/GET_EYESCOLOR_SUCCESS';

export const GET_NAILSHAPE_REQUEST_START: string = 'domainvalues/GET_NAILSHAPE_REQUEST_START';
export const GET_NAILSHAPE_REQUEST_FAILURE: string = 'domainvalues/GET_NAILSHAPE_REQUEST_FAILURE';
export const GET_NAILSHAPE_SUCCESS: string = 'domainvalues/GET_NAILSHAPE_SUCCESS';

export const GET_BODYTYPE_REQUEST_START: string = 'domainvalues/GET_BODYTYPE_REQUEST_START';
export const GET_BODYTYPE_REQUEST_FAILURE: string = 'domainvalues/GET_BODYTYPE_REQUEST_FAILURE';
export const GET_BODYTYPE_SUCCESS: string = 'domainvalues/GET_BODYTYPE_SUCCESS';

export const GET_HAIRCOLOR_REQUEST_START: string = 'domainvalues/GET_HAIRCOLOR_REQUEST_START';
export const GET_HAIRCOLOR_REQUEST_FAILURE: string = 'domainvalues/GET_HAIRCOLOR_REQUEST_FAILURE';
export const GET_HAIRCOLOR_SUCCESS: string = 'domainvalues/GET_HAIRCOLOR_SUCCESS';

export const GET_HAIRLENGTH_REQUEST_START: string = 'domainvalues/GET_HAIRLENGTH_REQUEST_START';
export const GET_HAIRLENGTH_REQUEST_FAILURE: string = 'domainvalues/GET_HAIRLENGTH_REQUEST_FAILURE';
export const GET_HAIRLENGTH_SUCCESS: string = 'domainvalues/GET_HAIRLENGTH_SUCCESS';

export const GET_BRANDS_REQUEST_START: string = 'domainvalues/GET_BRANDS_REQUEST_START';
export const GET_BRANDS_REQUEST_FAILURE: string = 'domainvalues/GET_BRANDS_REQUEST_FAILURE';
export const GET_BRANDS_SUCCESS: string = 'domainvalues/GET_BRANDS_SUCCESS';

export const GET_SKINPROBLEMS_REQUEST_START: string = 'domainvalues/GET_SKINPROBLEMS_REQUEST_START';
export const GET_SKINPROBLEMS_REQUEST_FAILURE: string = 'domainvalues/GET_SKINPROBLEMS_REQUEST_FAILURE';
export const GET_SKINPROBLEMS_SUCCESS: string = 'domainvalues/GET_SKINPROBLEMS_SUCCESS';

export const GET_EYEBROWTYPE_REQUEST_START: string = 'domainvalues/GET_EYEBROWTYPE_REQUEST_START';
export const GET_EYEBROWTYPE_REQUEST_FAILURE: string = 'domainvalues/GET_EYEBROWTYPE_REQUEST_FAILURE';
export const GET_EYEBROWTYPE_SUCCESS: string = 'domainvalues/GET_EYEBROWTYPE_SUCCESS';

export const GET_SHOPTYPE_REQUEST_START: string = 'domainvalues/GET_SHOPTYPE_REQUEST_START';
export const GET_SHOPTYPE_REQUEST_FAILURE: string = 'domainvalues/GET_SHOPTYPE_REQUEST_FAILURE';
export const GET_SHOPTYPE_SUCCESS: string = 'domainvalues/GET_SHOPTYPE_SUCCESS';

export const GET_FLAVOUR_REQUEST_START: string = 'domainvalues/GET_FLAVOUR_REQUEST_START';
export const GET_FLAVOUR_REQUEST_FAILURE: string = 'domainvalues/GET_FLAVOUR_REQUEST_FAILURE';
export const GET_FLAVOUR_SUCCESS: string = 'domainvalues/GET_FLAVOUR_SUCCESS';

export const GET_SERVICE_CATEGORIES_REQUEST_START: string = 'domainvalues/GET_SERVICE_CATEGORIES_REQUEST_START';
export const GET_SERVICE_CATEGORIES_REQUEST_FAILURE: string = 'domainvalues/GET_SERVICE_CATEGORIES_REQUEST_FAILURE';
export const GET_SERVICE_CATEGORIES_SUCCESS: string = 'domainvalues/GET_SERVICE_CATEGORIES_SUCCESS';

/** Initial State */
const initialState: IDomainValues = {
	isFetchingCountries: false,
	countries: null,

	isFetchingLanguages: false,
	languages: null,

	isFetchingCountryCallingCodes: false,
	countryCallingCodes: null,

	isFetchingCategories: false,
	categories: null,

	isFetchingColors: false,
	colors: null,

	isFetchingMaterials: false,
	materials: null,

	isFetchingPrints: false,
	prints: null,

	isFetchingSizes: false,
	sizes: null,

	isFetchingStyles: false,
	styles: null,

	isFetchingTopics: false,
	topics: null,

	isFetchingCurrencies: false,
	currencies: null,

	isFetchingSkinTypes: false,
	skinTypes: null,

	isFetchingSpecialities: false,
	specialities: null,

	isFetchingFormats: false,
	formats: null,

	isFetchingFormulations: false,
	formulations: null,

	isFetchingTreatments: false,
	treatments: null,

	isFetchingSports: false,
	sports: null,

	isFetchingHobbies: false,
	hobbies: null,

	isFetchingTrips: false,
	trips: null,

	isFetchingSocials: false,
	socials: null,

	isFetchingHairType: false,
	hairType: null,

	isFetchingScalpMoisture: false,
	scalpMoisture: null,

	isFetchingHairDresserVisitsPerMonth: false,
	hairDresserVisitsPerMonth: null,

	isFetchingHairProducts: false,
	hairProducts: null,

	isFetchingGoals: false,
	goals: null,

	isFetchingSkinColor: false,
	skinColor: null,

	isFetchingEyesColor: false,
	eyesColor: null,

	isFetchingNailShape: false,
	nailShape: null,

	isFetchingHairColor: false,
	hairColor: null,

	isFetchingHairLength: false,
	hairLength: null,

	isFetchingBrands: false,
	brands: null,

	isFetchingSkinProblems: false,
	skinProblems: null,

	isFetchingEyebrowType: false,
	eyebrowType: null,

	isFetchingShopType: false,
	shopType: null,

	isFetchingFlavours: false,
	flavours: null,

	isFetchingServiceCategories: false,
	serviceCategories: null,
};

/** Reducer */
export function domainValuesReducer(state = initialState, action: IDomainValuesAction): IDomainValues {
	switch (action.type) {
		case GET_COUNTRIES_REQUEST_START:
			return {
				...state,
				isFetchingCountries: true,
				errorCountries: false,
			};

		case GET_COUNTRIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingCountries: false,
				messageCountries: action.payload.messageCountries,
				errorCountries: true,
			};

		case GET_COUNTRIES_SUCCESS:
			return {
				...state,
				isFetchingCountries: false,
				countries: action.payload.countries,
			};

		case GET_LANGUAGES_REQUEST_START:
			return {
				...state,
				isFetchingLanguages: true,
				errorLanguages: false,
			};

		case GET_LANGUAGES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingLanguages: false,
				messageLanguages: action.payload.messageLanguages,
				errorLanguages: true,
			};

		case GET_LANGUAGES_SUCCESS:
			return {
				...state,
				isFetchingLanguages: false,
				languages: action.payload.languages,
			};

		case GET_COUNTRY_CALLING_CODES_REQUEST_START:
			return {
				...state,
				isFetchingCountryCallingCodes: true,
				errorCountryCallingCodes: false,
			};

		case GET_COUNTRY_CALLING_CODES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingCountryCallingCodes: false,
				messageCountryCallingCodes: action.payload.messageCountryCallingCodes,
				errorCountryCallingCodes: true,
			};

		case GET_COUNTRY_CALLING_CODES_SUCCESS:
			return {
				...state,
				isFetchingCountryCallingCodes: false,
				countryCallingCodes: action.payload.countryCallingCodes,
			};

		case GET_CATEGORIES_REQUEST_START:
			return {
				...state,
				isFetchingCategories: true,
				errorCategories: false,
			};

		case GET_CATEGORIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingCategories: false,
				messageCategories: action.payload.messageCategories,
				errorCategories: true,
			};

		case GET_CATEGORIES_SUCCESS:
			return {
				...state,
				isFetchingCategories: false,
				categories: action.payload.categories,
			};

		case GET_COLORS_REQUEST_START:
			return {
				...state,
				isFetchingColors: true,
				errorColors: false,
			};

		case GET_COLORS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingColors: false,
				messageColors: action.payload.messageColors,
				errorColors: true,
			};

		case GET_COLORS_SUCCESS:
			return {
				...state,
				isFetchingColors: false,
				colors: action.payload.colors,
			};

		case GET_MATERIALS_REQUEST_START:
			return {
				...state,
				isFetchingMaterials: true,
				errorMaterials: false,
			};

		case GET_MATERIALS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingMaterials: false,
				messageMaterials: action.payload.messageMaterials,
				errorMaterials: true,
			};

		case GET_MATERIALS_SUCCESS:
			return {
				...state,
				isFetchingMaterials: false,
				materials: action.payload.materials,
			};

		case GET_PRINTS_REQUEST_START:
			return {
				...state,
				isFetchingPrints: true,
				errorPrints: false,
			};

		case GET_PRINTS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingPrints: false,
				messagePrints: action.payload.messagePrints,
				errorPrints: true,
			};

		case GET_PRINTS_SUCCESS:
			return {
				...state,
				isFetchingPrints: false,
				prints: action.payload.prints,
			};

		case GET_SIZES_REQUEST_START:
			return {
				...state,
				isFetchingSizes: true,
				errorSizes: false,
			};

		case GET_SIZES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSizes: false,
				messageSizes: action.payload.messageSizes,
				errorSizes: true,
			};

		case GET_SIZES_SUCCESS:
			return {
				...state,
				isFetchingSizes: false,
				sizes: action.payload.sizes,
			};

		case GET_STYLES_REQUEST_START:
			return {
				...state,
				isFetchingStyles: true,
				errorStyles: false,
			};

		case GET_STYLES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingStyles: false,
				messageStyles: action.payload.messageStyles,
				errorStyles: true,
			};

		case GET_STYLES_SUCCESS:
			return {
				...state,
				isFetchingStyles: false,
				styles: action.payload.styles,
			};

		case GET_TOPICS_REQUEST_START:
			return {
				...state,
				isFetchingTopics: true,
				errorTopics: false,
			};

		case GET_TOPICS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingTopics: false,
				messageTopics: action.payload.messageTopics,
				errorTopics: true,
			};

		case GET_TOPICS_SUCCESS:
			return {
				...state,
				isFetchingTopics: false,
				topics: action.payload.topics,
			};

		case GET_CURRENCIES_REQUEST_START:
			return {
				...state,
				isFetchingCurrencies: true,
				errorCurrencies: false,
			};

		case GET_CURRENCIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingCurrencies: false,
				messageCurrencies: action.payload.messageCurrencies,
				errorCurrencies: true,
			};

		case GET_CURRENCIES_SUCCESS:
			return {
				...state,
				isFetchingCurrencies: false,
				currencies: action.payload.currencies,
			};

		case GET_SKIN_TYPES_REQUEST_START:
			return {
				...state,
				isFetchingSkinTypes: true,
				errorSkinTypes: false,
			};

		case GET_SKIN_TYPES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSkinTypes: false,
				messageSkinTypes: action.payload.messageSkinTypes,
				errorSkinTypes: true,
			};

		case GET_SKIN_TYPES_SUCCESS:
			return {
				...state,
				isFetchingSkinTypes: false,
				skinTypes: action.payload.skinTypes,
			};

		case GET_SPECIALITIES_REQUEST_START:
			return {
				...state,
				isFetchingSpecialities: true,
				errorSpecialities: false,
			};

		case GET_SPECIALITIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSpecialities: false,
				messageSpecialities: action.payload.messageSpecialities,
				errorSpecialities: true,
			};

		case GET_SPECIALITIES_SUCCESS:
			return {
				...state,
				isFetchingSpecialities: false,
				specialities: action.payload.specialities,
			};

		case GET_FORMATS_REQUEST_START:
			return {
				...state,
				isFetchingFormats: true,
				errorFormats: false,
			};

		case GET_FORMATS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingFormats: false,
				messageFormats: action.payload.messageFormats,
				errorFormats: true,
			};

		case GET_FORMATS_SUCCESS:
			return {
				...state,
				isFetchingFormats: false,
				formats: action.payload.formats,
			};

		case GET_FORMULATIONS_REQUEST_START:
			return {
				...state,
				isFetchingFormulations: true,
				errorFormulations: false,
			};

		case GET_FORMULATIONS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingFormulations: false,
				messageFormulations: action.payload.messageFormulations,
				errorFormulations: true,
			};

		case GET_FORMULATIONS_SUCCESS:
			return {
				...state,
				isFetchingFormulations: false,
				formulations: action.payload.formulations,
			};

		case GET_TREATMENTS_REQUEST_START:
			return {
				...state,
				isFetchingTreatments: true,
				errorTreatments: false,
			};

		case GET_TREATMENTS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingTreatments: false,
				messageTreatments: action.payload.messageTreatments,
				errorTreatments: true,
			};

		case GET_TREATMENTS_SUCCESS:
			return {
				...state,
				isFetchingTreatments: false,
				treatments: action.payload.treatments,
			};

		case GET_SPORTS_REQUEST_START:
			return {
				...state,
				isFetchingSports: true,
				errorSports: false,
			};

		case GET_SPORTS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSports: false,
				messageSports: action.payload.messageSports,
				errorSports: true,
			};

		case GET_SPORTS_SUCCESS:
			return {
				...state,
				isFetchingSports: false,
				sports: action.payload.sports,
			};

		case GET_HOBBIES_REQUEST_START:
			return {
				...state,
				isFetchingHobbies: true,
				errorHobbies: false,
			};

		case GET_HOBBIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHobbies: false,
				messageHobbies: action.payload.messageHobbies,
				errorHobbies: true,
			};

		case GET_HOBBIES_SUCCESS:
			return {
				...state,
				isFetchingHobbies: false,
				hobbies: action.payload.hobbies,
			};

		case GET_TRIPS_REQUEST_START:
			return {
				...state,
				isFetchingTrips: true,
				errorTrips: false,
			};

		case GET_TRIPS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingTrips: false,
				messageTrips: action.payload.messageTrips,
				errorTrips: true,
			};

		case GET_TRIPS_SUCCESS:
			return {
				...state,
				isFetchingTrips: false,
				trips: action.payload.trips,
			};

		case GET_SOCIALS_REQUEST_START:
			return {
				...state,
				isFetchingSocials: true,
				errorSocials: false,
			};

		case GET_SOCIALS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSocials: false,
				messageSocials: action.payload.messageSocials,
				errorSocials: true,
			};

		case GET_SOCIALS_SUCCESS:
			return {
				...state,
				isFetchingSocials: false,
				socials: action.payload.socials,
			};

		case GET_HAIRTYPE_REQUEST_START:
			return {
				...state,
				isFetchingHairType: true,
				errorHairType: false,
			};

		case GET_HAIRTYPE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHairType: false,
				messageHairType: action.payload.messageHairType,
				errorHairType: true,
			};

		case GET_HAIRTYPE_SUCCESS:
			return {
				...state,
				isFetchingHairType: false,
				hairType: action.payload.hairTypes,
			};

		case GET_SCALPMOISTURE_REQUEST_START:
			return {
				...state,
				isFetchingScalpMoisture: true,
				errorScalpMoisture: false,
			};

		case GET_SCALPMOISTURE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingScalpMoisture: false,
				messageScalpMoisture: action.payload.messageScalpMoisture,
				errorScalpMoisture: true,
			};

		case GET_SCALPMOISTURE_SUCCESS:
			return {
				...state,
				isFetchingScalpMoisture: false,
				scalpMoisture: action.payload.scalpMoisture,
			};

		case GET_HAIRDRESSERVISITSPERMONTH_REQUEST_START:
			return {
				...state,
				isFetchingHairDresserVisitsPerMonth: true,
				errorHairDresserVisitsPerMonth: false,
			};

		case GET_HAIRDRESSERVISITSPERMONTH_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHairDresserVisitsPerMonth: false,
				messageHairDresserVisitsPerMonth: action.payload.messageHairDresserVisitsPerMonth,
				errorHairDresserVisitsPerMonth: true,
			};

		case GET_HAIRDRESSERVISITSPERMONTH_SUCCESS:
			return {
				...state,
				isFetchingHairDresserVisitsPerMonth: false,
				hairDresserVisitsPerMonth: action.payload.hairDresserVisitsPerMonth,
			};

		case GET_HAIRPRODUCTS_REQUEST_START:
			return {
				...state,
				isFetchingHairProducts: true,
				errorHairProducts: false,
			};

		case GET_HAIRPRODUCTS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHairProducts: false,
				messageHairProducts: action.payload.messageHairProducts,
				errorHairProducts: true,
			};

		case GET_HAIRPRODUCTS_SUCCESS:
			return {
				...state,
				isFetchingHairProducts: false,
				hairProducts: action.payload.hairProducts,
			};

		case GET_GOALS_REQUEST_START:
			return {
				...state,
				isFetchingGoals: true,
				errorGoals: false,
			};

		case GET_GOALS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingGoals: false,
				messageGoals: action.payload.messageGoals,
				errorGoals: true,
			};

		case GET_GOALS_SUCCESS:
			return {
				...state,
				isFetchingGoals: false,
				goals: action.payload.goals,
			};

		case GET_SKINCOLOR_SUCCESS:
			return {
				...state,
				isFetchingSkinColor: false,
				skinColor: action.payload.skinColor,
			};

		case GET_SKINCOLOR_REQUEST_START:
			return {
				...state,
				isFetchingSkinColor: true,
				errorSkinColor: false,
			};

		case GET_SKINCOLOR_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSkinColor: false,
				messageSkinColor: action.payload.messageSkinColor,
				errorSkinColor: true,
			};

		case GET_EYESCOLOR_SUCCESS:
			return {
				...state,
				isFetchingEyesColor: false,
				eyesColor: action.payload.eyesColor,
			};

		case GET_EYESCOLOR_REQUEST_START:
			return {
				...state,
				isFetchingEyesColor: true,
				errorEyesColor: false,
			};

		case GET_EYESCOLOR_REQUEST_FAILURE:
			return {
				...state,
				isFetchingEyesColor: false,
				messageEyesColor: action.payload.messageEyesColor,
				errorEyesColor: true,
			};

		case GET_NAILSHAPE_SUCCESS:
			return {
				...state,
				isFetchingNailShape: false,
				nailShape: action.payload.nailShape,
			};

		case GET_NAILSHAPE_REQUEST_START:
			return {
				...state,
				isFetchingNailShape: true,
				errorNailShape: false,
			};

		case GET_NAILSHAPE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingNailShape: false,
				messageNailShape: action.payload.messageNailShape,
				errorNailShape: true,
			};

		case GET_BODYTYPE_SUCCESS:
			return {
				...state,
				isFetchingBodyType: false,
				bodyType: action.payload.bodyType,
			};

		case GET_BODYTYPE_REQUEST_START:
			return {
				...state,
				isFetchingBodyType: true,
				errorBodyType: false,
			};

		case GET_BODYTYPE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingBodyType: false,
				messageBodyType: action.payload.messageBodyType,
				errorBodyType: true,
			};

		case GET_HAIRCOLOR_SUCCESS:
			return {
				...state,
				isFetchingHairColor: false,
				hairColor: action.payload.hairColor,
			};

		case GET_HAIRCOLOR_REQUEST_START:
			return {
				...state,
				isFetchingHairColor: true,
				errorHairColor: false,
			};

		case GET_HAIRCOLOR_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHairColor: false,
				messageHairColor: action.payload.messageHairColor,
				errorHairColor: true,
			};

		case GET_HAIRLENGTH_SUCCESS:
			return {
				...state,
				isFetchingHairLength: false,
				hairLength: action.payload.hairLength,
			};

		case GET_HAIRLENGTH_REQUEST_START:
			return {
				...state,
				isFetchingHairLength: true,
				errorHairLength: false,
			};

		case GET_HAIRLENGTH_REQUEST_FAILURE:
			return {
				...state,
				isFetchingHairLength: false,
				messageHairLength: action.payload.messageHairLength,
				errorHairLength: true,
			};

		case GET_BRANDS_SUCCESS:
			return {
				...state,
				isFetchingBrands: false,
				brands: action.payload.brands,
			};

		case GET_BRANDS_REQUEST_START:
			return {
				...state,
				isFetchingBrands: true,
				errorBrands: false,
			};

		case GET_BRANDS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingBrands: false,
				messageBrands: action.payload.messageBrands,
				errorBrands: true,
			};

		case GET_SKINPROBLEMS_SUCCESS:
			return {
				...state,
				isFetchingSkinProblems: false,
				skinProblems: action.payload.skinProblems,
			};

		case GET_SKINPROBLEMS_REQUEST_START:
			return {
				...state,
				isFetchingSkinProblems: true,
				errorSkinProblems: false,
			};

		case GET_SKINPROBLEMS_REQUEST_FAILURE:
			return {
				...state,
				isFetchingSkinProblems: false,
				messageSkinProblems: action.payload.messageSkinProblems,
				errorSkinProblems: true,
			};

		case GET_EYEBROWTYPE_SUCCESS:
			return {
				...state,
				isFetchingEyebrowType: false,
				eyebrowType: action.payload.eyebrowType,
			};

		case GET_EYEBROWTYPE_REQUEST_START:
			return {
				...state,
				isFetchingEyebrowType: true,
				errorEyebrowType: false,
			};

		case GET_EYEBROWTYPE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingEyebrowType: false,
				messageEyebrowType: action.payload.messageEyebrowType,
				errorEyebrowType: true,
			};

		case GET_SHOPTYPE_SUCCESS:
			return {
				...state,
				isFetchingShopType: false,
				shopType: action.payload.shopType,
			};

		case GET_SHOPTYPE_REQUEST_START:
			return {
				...state,
				isFetchingShopType: true,
				errorShopType: false,
			};

		case GET_SHOPTYPE_REQUEST_FAILURE:
			return {
				...state,
				isFetchingShopType: false,
				messageShopType: action.payload.messageShopType,
				errorShopType: true,
			};

		case GET_FLAVOUR_SUCCESS:
			return {
				...state,
				isFetchingFlavours: false,
				flavours: action.payload.flavours,
			};

		case GET_FLAVOUR_REQUEST_START:
			return {
				...state,
				isFetchingFlavours: true,
				errorFlavours: false,
			};

		case GET_FLAVOUR_REQUEST_FAILURE:
			return {
				...state,
				isFetchingFlavours: false,
				messageFlavours: action.payload.messageFlavours,
				errorFlavours: true,
			};

		case GET_SERVICE_CATEGORIES_SUCCESS:
			return {
				...state,
				isFetchingServiceCategories: false,
				serviceCategories: action.payload.serviceCategories,
			};

		case GET_SERVICE_CATEGORIES_REQUEST_START:
			return {
				...state,
				isFetchingServiceCategories: true,
				errorServiceCategories: false,
			};

		case GET_SERVICE_CATEGORIES_REQUEST_FAILURE:
			return {
				...state,
				isFetchingServiceCategories: false,
				messageServiceCategories: action.payload.messageServiceCategories,
				errorServiceCategories: true,
			};

		default:
			return state;
	}
}

/** Action Creator */
export function getLanguageDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.languages === null && !getState().domainValues.isFetchingLanguages) {
			dispatch(getLanguagesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Language',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => {
							dispatch(getLanguagesSuccess(res));
							const selectedLanguage = res.find((x) => x.culture === I18nextSettings.fallbackLng);
							dispatch(changeUserLanguage(selectedLanguage.key, selectedLanguage.culture));
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getLanguagesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getLanguagesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getLanguagesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getCountryDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.countries === null && !getState().domainValues.isFetchingCountries) {
			dispatch(getCountriesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Country',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getCountriesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getCountriesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getCountriesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getCountriesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getCountryCallingCodeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (
			getState().domainValues.countryCallingCodes === null &&
			!getState().domainValues.isFetchingCountryCallingCodes
		) {
			dispatch(getCountryCallingCodesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/CountryCallingCode',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getCountryCallingCodesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getCountryCallingCodesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getCountryCallingCodesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getCountryCallingCodesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getCategoryDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.categories === null && !getState().domainValues.isFetchingCategories) {
			dispatch(getCategoriesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Category',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getCategoriesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getCategoriesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getCategoriesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getCategoriesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getColorDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.colors === null && !getState().domainValues.isFetchingColors) {
			dispatch(getColorsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Color',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getColorsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getColorsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getColorsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getColorsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getMaterialDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.materials === null && !getState().domainValues.isFetchingMaterials) {
			dispatch(getMaterialsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Material',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getMaterialsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getMaterialsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getMaterialsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getMaterialsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getPrintDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.prints === null && !getState().domainValues.isFetchingPrints) {
			dispatch(getPrintsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Print',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getPrintsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getPrintsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getPrintsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getPrintsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSizeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.sizes === null && !getState().domainValues.isFetchingSizes) {
			dispatch(getSizesRequestStart());

			return fetch(getState().fetchDefault.baseAPI + 'api/Size', Object.assign({}, getState().fetchDefault.requestInit))
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSizesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSizesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSizesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSizesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getStyleDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.styles === null && !getState().domainValues.isFetchingStyles) {
			dispatch(getStylesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Style',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getStylesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getStylesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getStylesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getStylesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getTopicDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.topics === null && !getState().domainValues.isFetchingTopics) {
			dispatch(getTopicsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Topic',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getTopicsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getTopicsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getTopicsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getTopicsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getCurrencyDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.currencies === null && !getState().domainValues.isFetchingCurrencies) {
			dispatch(getCurrenciesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Currency',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getCurrenciesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getCurrenciesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getCurrenciesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getCurrenciesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSkinTypeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.skinTypes === null && !getState().domainValues.isFetchingSkinTypes) {
			dispatch(getSkinTypesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/SkinType',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSkinTypesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSkinTypesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSkinTypesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSkinTypesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSpecialityDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.specialities === null && !getState().domainValues.isFetchingSpecialities) {
			dispatch(getSpecialitiesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Specialities',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSpecialitiesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSpecialitiesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSpecialitiesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSpecialitiesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getFormatDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.formats === null && !getState().domainValues.isFetchingFormats) {
			dispatch(getFormatsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Format',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getFormatsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getFormatsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getFormatsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getFormatsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getFormulationDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.formulations === null && !getState().domainValues.isFetchingFormulations) {
			dispatch(getFormulationsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Formulation',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getFormulationsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getFormulationsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getFormulationsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getFormulationsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getTreatmentDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.treatments === null && !getState().domainValues.isFetchingTreatments) {
			dispatch(getTreatmentsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Treatment',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getTreatmentsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getTreatmentsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getTreatmentsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getTreatmentsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSportDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.sports === null && !getState().domainValues.isFetchingSports) {
			dispatch(getSportsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Sport',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSportsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSportsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSportsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSportsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHobbyDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.hobbies === null && !getState().domainValues.isFetchingHobbies) {
			dispatch(getHobbiesRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Hobby',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHobbiesSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHobbiesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHobbiesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHobbiesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getTripDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.trips === null && !getState().domainValues.isFetchingTrips) {
			dispatch(getTripsRequestStart());

			return fetch(getState().fetchDefault.baseAPI + 'api/Trip', Object.assign({}, getState().fetchDefault.requestInit))
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getTripsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getTripsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getTripsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getTripsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSocialDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (getState().domainValues.socials === null && !getState().domainValues.isFetchingSocials) {
			dispatch(getSocialsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Social',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSocialsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSocialsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSocialsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSocialsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHairTypeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.hairType && !getState().domainValues.isFetchingHairType) {
			dispatch(getHairTypeRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/HairType',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHairTypeSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHairTypeRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHairTypeRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHairTypeRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getScalpMoistureDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.scalpMoisture && !getState().domainValues.isFetchingScalpMoisture) {
			dispatch(getScalpMoistureRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/ScalpMoisture',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getScalpMoistureSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getScalpMoistureRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getScalpMoistureRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getScalpMoistureRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHairDresserVisitsPerMonthDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (
			!getState().domainValues.hairDresserVisitsPerMonth &&
			!getState().domainValues.isFetchingHairDresserVisitsPerMonth
		) {
			dispatch(getHairDresserVisitsPerMonthRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/HairDresserVisitsPerMonth',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHairDresserVisitsPerMonthSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHairDresserVisitsPerMonthRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHairDresserVisitsPerMonthRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHairDresserVisitsPerMonthRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHairProductsDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.hairProducts && !getState().domainValues.isFetchingHairProducts) {
			dispatch(getHairProductsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/HairProduct',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHairProductsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHairProductsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHairProductsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHairProductsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getGoalsDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.goals && !getState().domainValues.isFetchingGoals) {
			dispatch(getGoalsRequestStart());

			return fetch(getState().fetchDefault.baseAPI + 'api/Goal', Object.assign({}, getState().fetchDefault.requestInit))
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getGoalsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getGoalsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getGoalsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getGoalsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSkinColorDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.skinColor && !getState().domainValues.isFetchingSkinColor) {
			dispatch(getSkinColorRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/SkinColor',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSkinColorSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSkinColorRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSkinColorRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSkinColorRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getEyesColorDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.eyesColor && !getState().domainValues.isFetchingEyesColor) {
			dispatch(getEyesColorRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/EyesColor',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getEyesColorSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getEyesColorRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getEyesColorRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getEyesColorRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getNailShapeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.nailShape && !getState().domainValues.isFetchingNailShape) {
			dispatch(getNailShapeRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/NailShape',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getNailShapeSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getNailShapeRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getNailShapeRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getNailShapeRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getBodyTypeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.bodyType && !getState().domainValues.isFetchingBodyType) {
			dispatch(getBodyTypeRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/BodyType',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getBodyTypeSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getBodyTypeRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getBodyTypeRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getBodyTypeRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHairColorDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.hairColor && !getState().domainValues.isFetchingHairColor) {
			dispatch(getHairColorRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/HairColor',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHairColorSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHairColorRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHairColorRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHairColorRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getHairLengthDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.hairLength && !getState().domainValues.isFetchingHairLength) {
			dispatch(getHairLengthRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/HairLength',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getHairLengthSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getHairLengthRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getHairLengthRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getHairLengthRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getBrandsDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.brands && !getState().domainValues.isFetchingBrands) {
			dispatch(getBrandsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Brand',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getBrandsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getBrandsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getBrandsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getBrandsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getSkinProblemsDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.skinProblems && !getState().domainValues.isFetchingSkinProblems) {
			dispatch(getSkinProblemsRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/SkinProblem',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getSkinProblemsSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getSkinProblemsRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getSkinProblemsRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getSkinProblemsRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getEyebrowTypeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.eyebrowType && !getState().domainValues.isFetchingEyebrowType) {
			dispatch(getEyebrowTypeRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/EyebrowType',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getEyebrowTypeSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getEyebrowTypeRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getEyebrowTypeRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getEyebrowTypeRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getShopTypeDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.shopType && !getState().domainValues.isFetchingShopType) {
			dispatch(getShopTypeRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/ShopType',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getShopTypeSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getShopTypeRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getShopTypeRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getShopTypeRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getFlavourDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.flavours && !getState().domainValues.isFetchingFlavours) {
			dispatch(getFlavoursRequestStart());

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Flavour',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => dispatch(getFlavoursSuccess(res)));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getFlavoursRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getFlavoursRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getFlavoursRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getServiceCategoriesDomainValues() {
	return (dispatch, getState: () => IStore) => {
		if (!getState().domainValues.serviceCategories && !getState().domainValues.isFetchingServiceCategories) {
			dispatch(getServiceCategoriesRequestStart());
			return fetch(
				getState().fetchDefault.baseAPI + 'api/ServiceCategory',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((serviceCategories: IDomainValue[]) => {
							return fetch(
								getState().fetchDefault.baseAPI + 'api/shop/ShopTypeServiceCategories',
								Object.assign({}, getState().fetchDefault.requestInit),
							).then((r2) => {
								if (r2.ok) {
									return r2
										.json()
										.then((conn: IServiceCategoryShopType[]) =>
											serviceCategories.map(
												(sc): IServiceCategoryDomainValue => ({
													...sc,
													serviceCategoryShopTypes: conn
														.filter((c) => c.serviceCategoryId === sc.key)
														.sort((a, b) => b.order - a.order)
														.map((c) => c.shopTypeId),
												}),
											),
										)
										.then((all) => dispatch(getServiceCategoriesSuccess(all)));
								} else {
									const status: number = res.status;
									const statusText: string = res.statusText;
									return res
										.json()
										.then((res) => {
											res.status = status;
											res.statusText = statusText;
											dispatch(getServiceCategoriesRequestFailure(res));
										})
										.catch(() => {
											const message: any = { status, statusText };
											dispatch(getServiceCategoriesRequestFailure(message));
										});
								}
							});
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(getServiceCategoriesRequestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(getServiceCategoriesRequestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(getServiceCategoriesRequestFailure(err));
				});
		}
	};
}

/** Action Creator */
export function getCountriesRequestStart(): IDomainValuesAction {
	return {
		type: GET_COUNTRIES_REQUEST_START,
	};
}

/** Action Creator */
export function getCountriesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_COUNTRIES_REQUEST_FAILURE,
		payload: {
			messageCountries: message,
		},
	};
}

/** Action Creator */
export function getCountriesSuccess(countries: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_COUNTRIES_SUCCESS,
		payload: {
			countries,
		},
	};
}

/** Action Creator */
export function getLanguagesRequestStart(): IDomainValuesAction {
	return {
		type: GET_LANGUAGES_REQUEST_START,
	};
}

/** Action Creator */
export function getLanguagesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_LANGUAGES_REQUEST_FAILURE,
		payload: {
			messageLanguages: message,
		},
	};
}

/** Action Creator */
export function getLanguagesSuccess(languages: ILanguage[]): IDomainValuesAction {
	return {
		type: GET_LANGUAGES_SUCCESS,
		payload: {
			languages,
		},
	};
}

/** Action Creator */
export function getCountryCallingCodesRequestStart(): IDomainValuesAction {
	return {
		type: GET_COUNTRY_CALLING_CODES_REQUEST_START,
	};
}

/** Action Creator */
export function getCountryCallingCodesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_COUNTRY_CALLING_CODES_REQUEST_FAILURE,
		payload: {
			messageLanguages: message,
		},
	};
}

/** Action Creator */
export function getCountryCallingCodesSuccess(
	countryCallingCodes: ICountryCallingCodeDomainValue[],
): IDomainValuesAction {
	return {
		type: GET_COUNTRY_CALLING_CODES_SUCCESS,
		payload: {
			countryCallingCodes,
		},
	};
}

/** Action Creator */
export function getCategoriesRequestStart(): IDomainValuesAction {
	return {
		type: GET_CATEGORIES_REQUEST_START,
	};
}

/** Action Creator */
export function getCategoriesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_CATEGORIES_REQUEST_FAILURE,
		payload: {
			messageCategories: message,
		},
	};
}

/** Action Creator */
export function getCategoriesSuccess(categories: ICategoryDomainValue[]): IDomainValuesAction {
	return {
		type: GET_CATEGORIES_SUCCESS,
		payload: {
			categories,
		},
	};
}

/** Action Creator */
export function getColorsRequestStart(): IDomainValuesAction {
	return {
		type: GET_COLORS_REQUEST_START,
	};
}

/** Action Creator */
export function getColorsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_COLORS_REQUEST_FAILURE,
		payload: {
			messageColors: message,
		},
	};
}

/** Action Creator */
export function getColorsSuccess(colors: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_COLORS_SUCCESS,
		payload: {
			colors,
		},
	};
}

/** Action Creator */
export function getMaterialsRequestStart(): IDomainValuesAction {
	return {
		type: GET_MATERIALS_REQUEST_START,
	};
}

/** Action Creator */
export function getMaterialsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_MATERIALS_REQUEST_FAILURE,
		payload: {
			messageMaterials: message,
		},
	};
}

/** Action Creator */
export function getMaterialsSuccess(materials: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_MATERIALS_SUCCESS,
		payload: {
			materials,
		},
	};
}

/** Action Creator */
export function getPrintsRequestStart(): IDomainValuesAction {
	return {
		type: GET_PRINTS_REQUEST_START,
	};
}

/** Action Creator */
export function getPrintsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_PRINTS_REQUEST_FAILURE,
		payload: {
			messagePrints: message,
		},
	};
}

/** Action Creator */
export function getPrintsSuccess(prints: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_PRINTS_SUCCESS,
		payload: {
			prints,
		},
	};
}

/** Action Creator */
export function getSizesRequestStart(): IDomainValuesAction {
	return {
		type: GET_SIZES_REQUEST_START,
	};
}

/** Action Creator */
export function getSizesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SIZES_REQUEST_FAILURE,
		payload: {
			messageSizes: message,
		},
	};
}

/** Action Creator */
export function getSizesSuccess(sizes: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SIZES_SUCCESS,
		payload: {
			sizes,
		},
	};
}

/** Action Creator */
export function getStylesRequestStart(): IDomainValuesAction {
	return {
		type: GET_STYLES_REQUEST_START,
	};
}

/** Action Creator */
export function getStylesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_STYLES_REQUEST_FAILURE,
		payload: {
			messageStyles: message,
		},
	};
}

/** Action Creator */
export function getStylesSuccess(styles: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_STYLES_SUCCESS,
		payload: {
			styles,
		},
	};
}

/** Action Creator */
export function getTopicsRequestStart(): IDomainValuesAction {
	return {
		type: GET_TOPICS_REQUEST_START,
	};
}

/** Action Creator */
export function getTopicsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_TOPICS_REQUEST_FAILURE,
		payload: {
			messageTopics: message,
		},
	};
}

/** Action Creator */
export function getTopicsSuccess(topics: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_TOPICS_SUCCESS,
		payload: {
			topics,
		},
	};
}

/** Action Creator */
export function getCurrenciesRequestStart(): IDomainValuesAction {
	return {
		type: GET_CURRENCIES_REQUEST_START,
	};
}

/** Action Creator */
export function getCurrenciesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_CURRENCIES_REQUEST_FAILURE,
		payload: {
			messageCurrencies: message,
		},
	};
}

/** Action Creator */
export function getCurrenciesSuccess(currencies: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_CURRENCIES_SUCCESS,
		payload: {
			currencies,
		},
	};
}

/** Action Creator */
export function getSkinTypesRequestStart(): IDomainValuesAction {
	return {
		type: GET_SKIN_TYPES_REQUEST_START,
	};
}

/** Action Creator */
export function getSkinTypesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SKIN_TYPES_REQUEST_FAILURE,
		payload: {
			messageSkinTypes: message,
		},
	};
}

/** Action Creator */
export function getSkinTypesSuccess(skinTypes: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SKIN_TYPES_SUCCESS,
		payload: {
			skinTypes,
		},
	};
}

/** Action Creator */
export function getSpecialitiesRequestStart(): IDomainValuesAction {
	return {
		type: GET_SPECIALITIES_REQUEST_START,
	};
}

/** Action Creator */
export function getSpecialitiesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SPECIALITIES_REQUEST_FAILURE,
		payload: {
			messageSpecialities: message,
		},
	};
}

/** Action Creator */
export function getSpecialitiesSuccess(specialities: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SPECIALITIES_SUCCESS,
		payload: {
			specialities,
		},
	};
}

/** Action Creator */
export function getFormatsRequestStart(): IDomainValuesAction {
	return {
		type: GET_FORMATS_REQUEST_START,
	};
}

/** Action Creator */
export function getFormatsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_FORMATS_REQUEST_FAILURE,
		payload: {
			messageFormats: message,
		},
	};
}

/** Action Creator */
export function getFormatsSuccess(formats: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_FORMATS_SUCCESS,
		payload: {
			formats,
		},
	};
}

/** Action Creator */
export function getFormulationsRequestStart(): IDomainValuesAction {
	return {
		type: GET_FORMULATIONS_REQUEST_START,
	};
}

/** Action Creator */
export function getFormulationsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_FORMULATIONS_REQUEST_FAILURE,
		payload: {
			messageFormulations: message,
		},
	};
}

/** Action Creator */
export function getFormulationsSuccess(formulations: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_FORMULATIONS_SUCCESS,
		payload: {
			formulations,
		},
	};
}

/** Action Creator */
export function getTreatmentsRequestStart(): IDomainValuesAction {
	return {
		type: GET_TREATMENTS_REQUEST_START,
	};
}

/** Action Creator */
export function getTreatmentsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_TREATMENTS_REQUEST_FAILURE,
		payload: {
			messageTreatments: message,
		},
	};
}

/** Action Creator */
export function getTreatmentsSuccess(treatments: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_TREATMENTS_SUCCESS,
		payload: {
			treatments,
		},
	};
}

/** Action Creator */
export function getSportsRequestStart(): IDomainValuesAction {
	return {
		type: GET_SPORTS_REQUEST_START,
	};
}

/** Action Creator */
export function getSportsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SPORTS_REQUEST_FAILURE,
		payload: {
			messageSports: message,
		},
	};
}

/** Action Creator */
export function getSportsSuccess(sports: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SPORTS_SUCCESS,
		payload: {
			sports,
		},
	};
}

/** Action Creator */
export function getHobbiesRequestStart(): IDomainValuesAction {
	return {
		type: GET_HOBBIES_REQUEST_START,
	};
}

/** Action Creator */
export function getHobbiesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HOBBIES_REQUEST_FAILURE,
		payload: {
			messageHobbies: message,
		},
	};
}

/** Action Creator */
export function getHobbiesSuccess(hobbies: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HOBBIES_SUCCESS,
		payload: {
			hobbies,
		},
	};
}

/** Action Creator */
export function getTripsRequestStart(): IDomainValuesAction {
	return {
		type: GET_TRIPS_REQUEST_START,
	};
}

/** Action Creator */
export function getTripsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_TRIPS_REQUEST_FAILURE,
		payload: {
			messageTrips: message,
		},
	};
}

/** Action Creator */
export function getTripsSuccess(trips: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_TRIPS_SUCCESS,
		payload: {
			trips,
		},
	};
}

/** Action Creator */
export function getSocialsRequestStart(): IDomainValuesAction {
	return {
		type: GET_SOCIALS_REQUEST_START,
	};
}

/** Action Creator */
export function getSocialsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SOCIALS_REQUEST_FAILURE,
		payload: {
			messageSocials: message,
		},
	};
}

/** Action Creator */
export function getSocialsSuccess(socials: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SOCIALS_SUCCESS,
		payload: {
			socials,
		},
	};
}

/** Action Creator */
export function getHairTypeRequestStart(): IDomainValuesAction {
	return {
		type: GET_HAIRTYPE_REQUEST_START,
	};
}

/** Action Creator */
export function getHairTypeRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HAIRTYPE_REQUEST_FAILURE,
		payload: {
			messageHairType: message,
		},
	};
}

/** Action Creator */
export function getHairTypeSuccess(hairTypes: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HAIRTYPE_SUCCESS,
		payload: {
			hairTypes,
		},
	};
}

/** Action Creator */
export function getScalpMoistureRequestStart(): IDomainValuesAction {
	return {
		type: GET_SCALPMOISTURE_REQUEST_START,
	};
}

/** Action Creator */
export function getScalpMoistureRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SCALPMOISTURE_REQUEST_FAILURE,
		payload: {
			messageScalpMoisture: message,
		},
	};
}

/** Action Creator */
export function getScalpMoistureSuccess(scalpMoisture: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SCALPMOISTURE_SUCCESS,
		payload: {
			scalpMoisture,
		},
	};
}

/** Action Creator */
export function getHairDresserVisitsPerMonthRequestStart(): IDomainValuesAction {
	return {
		type: GET_HAIRDRESSERVISITSPERMONTH_REQUEST_START,
	};
}

/** Action Creator */
export function getHairDresserVisitsPerMonthRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HAIRDRESSERVISITSPERMONTH_REQUEST_FAILURE,
		payload: {
			messageHairDresserVisitsPerMonth: message,
		},
	};
}

/** Action Creator */
export function getHairDresserVisitsPerMonthSuccess(hairDresserVisitsPerMonth: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HAIRDRESSERVISITSPERMONTH_SUCCESS,
		payload: {
			hairDresserVisitsPerMonth,
		},
	};
}

/** Action Creator */
export function getHairProductsRequestStart(): IDomainValuesAction {
	return {
		type: GET_HAIRPRODUCTS_REQUEST_START,
	};
}

/** Action Creator */
export function getHairProductsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HAIRPRODUCTS_REQUEST_FAILURE,
		payload: {
			messageHairProducts: message,
		},
	};
}

/** Action Creator */
export function getHairProductsSuccess(hairProducts: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HAIRPRODUCTS_SUCCESS,
		payload: {
			hairProducts,
		},
	};
}

/** Action Creator */
export function getGoalsRequestStart(): IDomainValuesAction {
	return {
		type: GET_GOALS_REQUEST_START,
	};
}

/** Action Creator */
export function getGoalsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_GOALS_REQUEST_FAILURE,
		payload: {
			messageGoals: message,
		},
	};
}

/** Action Creator */
export function getGoalsSuccess(goals: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_GOALS_SUCCESS,
		payload: {
			goals,
		},
	};
}

/** Action Creator */
export function getSkinColorRequestStart(): IDomainValuesAction {
	return {
		type: GET_SKINCOLOR_REQUEST_START,
	};
}

/** Action Creator */
export function getSkinColorRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SKINCOLOR_REQUEST_FAILURE,
		payload: {
			messageSkinColor: message,
		},
	};
}

/** Action Creator */
export function getSkinColorSuccess(skinColor: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SKINCOLOR_SUCCESS,
		payload: {
			skinColor,
		},
	};
}

/** Action Creator */
export function getEyesColorRequestStart(): IDomainValuesAction {
	return {
		type: GET_EYESCOLOR_REQUEST_START,
	};
}

/** Action Creator */
export function getEyesColorRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_EYESCOLOR_REQUEST_FAILURE,
		payload: {
			messageEyesColor: message,
		},
	};
}

/** Action Creator */
export function getEyesColorSuccess(eyesColor: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_EYESCOLOR_SUCCESS,
		payload: {
			eyesColor,
		},
	};
}

/** Action Creator */
export function getNailShapeRequestStart(): IDomainValuesAction {
	return {
		type: GET_NAILSHAPE_REQUEST_START,
	};
}

/** Action Creator */
export function getNailShapeRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_NAILSHAPE_REQUEST_FAILURE,
		payload: {
			messageNailShape: message,
		},
	};
}

/** Action Creator */
export function getNailShapeSuccess(nailShape: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_NAILSHAPE_SUCCESS,
		payload: {
			nailShape,
		},
	};
}

/** Action Creator */
export function getBodyTypeRequestStart(): IDomainValuesAction {
	return {
		type: GET_BODYTYPE_REQUEST_START,
	};
}

/** Action Creator */
export function getBodyTypeRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_BODYTYPE_REQUEST_FAILURE,
		payload: {
			messageBodyType: message,
		},
	};
}

/** Action Creator */
export function getBodyTypeSuccess(bodyType: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_BODYTYPE_SUCCESS,
		payload: {
			bodyType,
		},
	};
}

/** Action Creator */
export function getHairColorRequestStart(): IDomainValuesAction {
	return {
		type: GET_HAIRCOLOR_REQUEST_START,
	};
}

/** Action Creator */
export function getHairColorRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HAIRCOLOR_REQUEST_FAILURE,
		payload: {
			messageHairColor: message,
		},
	};
}

/** Action Creator */
export function getHairColorSuccess(hairColor: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HAIRCOLOR_SUCCESS,
		payload: {
			hairColor,
		},
	};
}

/** Action Creator */
export function getHairLengthRequestStart(): IDomainValuesAction {
	return {
		type: GET_HAIRLENGTH_REQUEST_START,
	};
}

/** Action Creator */
export function getHairLengthRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_HAIRLENGTH_REQUEST_FAILURE,
		payload: {
			messageHairLength: message,
		},
	};
}

/** Action Creator */
export function getHairLengthSuccess(hairLength: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_HAIRLENGTH_SUCCESS,
		payload: {
			hairLength,
		},
	};
}

/** Action Creator */
export function getBrandsRequestStart(): IDomainValuesAction {
	return {
		type: GET_BRANDS_REQUEST_START,
	};
}

/** Action Creator */
export function getBrandsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_BRANDS_REQUEST_FAILURE,
		payload: {
			messageBrands: message,
		},
	};
}

/** Action Creator */
export function getBrandsSuccess(brands: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_BRANDS_SUCCESS,
		payload: {
			brands,
		},
	};
}

/** Action Creator */
export function getSkinProblemsRequestStart(): IDomainValuesAction {
	return {
		type: GET_SKINPROBLEMS_REQUEST_START,
	};
}

/** Action Creator */
export function getSkinProblemsRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SKINPROBLEMS_REQUEST_FAILURE,
		payload: {
			messageSkinProblems: message,
		},
	};
}

/** Action Creator */
export function getSkinProblemsSuccess(skinProblems: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SKINPROBLEMS_SUCCESS,
		payload: {
			skinProblems,
		},
	};
}

/** Action Creator */
export function getEyebrowTypeRequestStart(): IDomainValuesAction {
	return {
		type: GET_EYEBROWTYPE_REQUEST_START,
	};
}

/** Action Creator */
export function getEyebrowTypeRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_EYEBROWTYPE_REQUEST_FAILURE,
		payload: {
			messageEyebrowType: message,
		},
	};
}

/** Action Creator */
export function getEyebrowTypeSuccess(eyebrowType: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_EYEBROWTYPE_SUCCESS,
		payload: {
			eyebrowType,
		},
	};
}

/** Action Creator */
export function getShopTypeRequestStart(): IDomainValuesAction {
	return {
		type: GET_SHOPTYPE_REQUEST_START,
	};
}

/** Action Creator */
export function getShopTypeRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SHOPTYPE_REQUEST_FAILURE,
		payload: {
			messageShopType: message,
		},
	};
}

/** Action Creator */
export function getShopTypeSuccess(shopType: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SHOPTYPE_SUCCESS,
		payload: {
			shopType,
		},
	};
}

/** Action Creator */
export function getFlavoursRequestStart(): IDomainValuesAction {
	return {
		type: GET_FLAVOUR_REQUEST_START,
	};
}

/** Action Creator */
export function getFlavoursRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_FLAVOUR_REQUEST_FAILURE,
		payload: {
			messageFlavours: message,
		},
	};
}

/** Action Creator */
export function getFlavoursSuccess(flavours: IDomainValue[]): IDomainValuesAction {
	return {
		type: GET_FLAVOUR_SUCCESS,
		payload: {
			flavours,
		},
	};
}

/** Action Creator */
export function getServiceCategoriesRequestStart(): IDomainValuesAction {
	return {
		type: GET_SERVICE_CATEGORIES_REQUEST_START,
	};
}

/** Action Creator */
export function getServiceCategoriesRequestFailure(message: any): IDomainValuesAction {
	return {
		type: GET_SERVICE_CATEGORIES_REQUEST_FAILURE,
		payload: {
			messageServiceCategories: message,
		},
	};
}

/** Action Creator */
export function getServiceCategoriesSuccess(serviceCategories: IServiceCategoryDomainValue[]): IDomainValuesAction {
	return {
		type: GET_SERVICE_CATEGORIES_SUCCESS,
		payload: {
			serviceCategories,
		},
	};
}

export const domainValuesMap: { [key in keyof IDomainValues]: () => (dispatch: any, getState: any) => Promise<any> } = {
	languages: getLanguageDomainValues,
	countries: getCountryDomainValues,
	countryCallingCodes: getCountryCallingCodeDomainValues,
	categories: getCategoryDomainValues,
	colors: getColorDomainValues,
	materials: getMaterialDomainValues,
	prints: getPrintDomainValues,
	sizes: getSizeDomainValues,
	styles: getStyleDomainValues,
	topics: getTopicDomainValues,
	currencies: getCurrencyDomainValues,
	skinTypes: getSkinTypeDomainValues,
	specialities: getSpecialityDomainValues,
	formats: getFormatDomainValues,
	formulations: getFormulationDomainValues,
	treatments: getTreatmentDomainValues,
	sports: getSportDomainValues,
	hobbies: getHobbyDomainValues,
	trips: getTripDomainValues,
	socials: getSocialDomainValues,
	hairType: getHairTypeDomainValues,
	scalpMoisture: getScalpMoistureDomainValues,
	hairDresserVisitsPerMonth: getHairDresserVisitsPerMonthDomainValues,
	hairProducts: getHairProductsDomainValues,
	goals: getGoalsDomainValues,
	skinColor: getSkinColorDomainValues,
	eyesColor: getEyesColorDomainValues,
	nailShape: getNailShapeDomainValues,
	bodyType: getBodyTypeDomainValues,
	hairColor: getHairColorDomainValues,
	hairLength: getHairLengthDomainValues,
	brands: getBrandsDomainValues,
	skinProblems: getSkinProblemsDomainValues,
	eyebrowType: getEyebrowTypeDomainValues,
	shopType: getShopTypeDomainValues,
	flavours: getFlavourDomainValues,
	serviceCategories: getServiceCategoriesDomainValues,
};
